export const AdminRole = "IT Admin";
export const SuperAdminRole = "Superadmin";
export const AccountantRole = "Accountant";
export const VisitorRole = "Visitor";
